import { useContext, useEffect, useState } from "react";
import { Grid, MenuItem, TextField, Typography, Card, Box } from "@mui/material";
import UserContext from "../../../navigation/context/userContext";
import AuxAlert from "../../../components/alert";
import { GetDatos, UpdateDatos } from "../../../controllers/company/CompanyProfileController";

import SaveIcon from '@mui/icons-material/Save';
import { LoadingButton } from "@mui/lab";
import ReactQuill from "react-quill";

export default function DatosGenerales(props) {
    const { userData } = useContext(UserContext)
    const [categories, setCategories] = useState([]);
    
    const [category, setCategory] = useState('');
    const [errorCategory, setErrorCategory] = useState(false);

    const [tradeName, setTradeName] = useState('');
    const [errorTradeName, setErrorTradeName] = useState(false);

    const [slogan, setSlogan] = useState('');
    const [description, setDescription] = useState('');
    const [errorDescription, setErrorDescription] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    
    // Alertas
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(true);

    useEffect(() => {
        getInfo();
    }, []);

    const getInfo = async () => {
        let response = await GetDatos();
        if (response.success === true) {
            setCategories(response.data.categorias);
            setCategory(response.data.empresa.Categoria);
            setTradeName(response.data.empresa.NombreComercial);
            setDescription(response.data.empresa.descripcion || '');
            setSlogan(response.data.empresa.slogan || '');
        }
    }

    const formVerification = () => {
        let ban = 0;
        if (description === '') { setErrorDescription(true); ban = 1; }
        if (category === '') { setErrorCategory(true); ban = 1; }
        if (tradeName === '') { setErrorTradeName(true); ban = 1; }
        return ban;
    }
    
    const handleUpdateDatosGenerales = async () => {
        if (formVerification() === 0) {
            setIsLoading(true);
            let response = await UpdateDatos(tradeName, category, description, slogan);
            setSuccess(response.success);
            setTitle(response.success ? 'Operación Exitosa' : 'Operación Fallida');
            setMessage(response.message);
            setOpen(true);
            setTimeout(() => setOpen(false), 5000);
            setIsLoading(false);
        }
    }

    const cardStyle = { elevation: 0, sx: { border: '1px solid #e0e0e0', borderRadius: 3, p: { xs: 2, sm: 4 }, bgcolor: '#ffffff' } };

    return (
        <Card {...cardStyle}>
            <Grid container spacing={3}>
                <Grid item xs={12} display='flex' flexDirection={{ xs: 'column', sm: 'row' }} justifyContent='space-between' alignItems={{ xs: 'flex-start', sm: 'center' }} gap={2}>
                    <Box>
                        <Typography variant='h6' sx={{ fontWeight: 800, color: '#222' }}>Información Básica</Typography>
                        <Typography variant="body2" color="text.secondary">Detalles públicos de la identidad de tu negocio.</Typography>
                    </Box>
                    <LoadingButton
                        loading={isLoading}
                        variant="contained"
                        onClick={handleUpdateDatosGenerales}
                        startIcon={<SaveIcon />}
                        disableElevation
                        sx={{ borderRadius: 2, fontWeight: 'bold', textTransform: 'none' }}
                    >
                        Guardar Cambios
                    </LoadingButton>
                </Grid>
                
                <Grid item xs={12}>
                     <Typography variant="subtitle2" fontWeight="bold" mb={1}>Datos Legales</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField disabled fullWidth size="small" variant="outlined" label='Razón Social / Nombre Legal' value={userData.entity.name} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField disabled fullWidth size="small" variant="outlined" label='Documento (RUT/NIT/RIF)' value={`${userData.entity.document_type}-${userData.entity.document_number}`} />
                </Grid>

                <Grid item xs={12} mt={2}>
                     <Typography variant="subtitle2" fontWeight="bold" mb={1}>Datos Comerciales</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth size="small"
                        variant="outlined"
                        label='Nombre Comercial'
                        value={tradeName}
                        onChange={(e) => { setTradeName(e.target.value); setErrorTradeName(false); }}
                        error={errorTradeName}
                        helperText={errorTradeName && 'Requerido'}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth size="small" select
                        label="Categoría"
                        value={category}
                        onChange={(e) => { setCategory(e.target.value); setErrorCategory(false); }}
                        error={errorCategory}
                        helperText={errorCategory && 'Requerido'}
                    >
                        <MenuItem value=''>Seleccione una Categoría</MenuItem>
                        {categories.map((item) => (
                            <MenuItem key={item.idcategoria} value={item.idcategoria}>{item.nombre}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        fullWidth size="small"
                        variant="outlined"
                        label='Eslogan corto (Opcional)'
                        value={slogan}
                        onChange={(e) => setSlogan(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} mt={1}>
                    <Typography variant="subtitle2" fontWeight="bold" mb={0.5}>Descripción del Negocio</Typography>
                    <Box sx={{ '.ql-container': { borderBottomLeftRadius: 8, borderBottomRightRadius: 8, fontFamily: 'inherit' }, '.ql-toolbar': { borderTopLeftRadius: 8, borderTopRightRadius: 8 } }}>
                        <ReactQuill
                            theme="snow"
                            value={description}
                            onChange={setDescription}
                            onBlur={() => setErrorDescription(description === '')}
                            style={{ height: 200, marginBottom: '50px' }}
                        />
                    </Box>
                    {errorDescription && <Typography variant="caption" color="error.main">Debes ingresar una descripción.</Typography>}
                </Grid>
            </Grid>
            
            <AuxAlert open={open} success={success} title={title} message={message} />
        </Card>
    );
}